import React from 'react';
import { IconButton, SvgIcon, Theme, Tooltip, useTheme, Grid } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { APP_SETTINGS } from 'config/constants';
import {
  CommentOutlined as CommentOutlinedIcon,
  SettingsOutlined as SettingsOutlinedIcon,
} from '@mui/icons-material';
import FeedbackDrawer from 'src/_common/components/drawer/FeedbackDrawer';
import { toggleDrawer } from 'src/_common/handlers/services';
import { RootState } from 'src/_common/models/redux/store';
import { useSelector } from 'react-redux';
import GrammarSettingsDrawer from './GrammarSettingsDrawer';
import GrammarStatsDrawer from './GrammarStatsDrawer';

const useStyles = makeStyles((theme: Theme) => ({
  iconButton: {
    padding: '6px',
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  compareModeContainer: {
    [theme.breakpoints.down(900)]: {
      display: 'none',
    },
  },
  premiumIcon: {
    fontSize: '15px',
    position: 'absolute',
    bottom: '2px',
    right: '-5px',
  },
  paddingRightDrawerControls: {
    paddingRight: (props: any) =>
      props?.platform?.isIE &&
      props?.platform?.isExtension &&
      props?.platform?.extensionMetaData?.type === 'ms-word'
        ? '15px'
        : '25px',
  },
  ipadVisibility: {
    [theme.breakpoints.up(1020)]: {
      display: 'none',
    },
  },
}));

export default function GrammarCheckerDrawerControlBar(props: any) {
  const theme = useTheme();
  const quillDrawer = useSelector((state: RootState) => state?.common?.quillDrawer);
  const tooltipPlacement = props.tooltipPlacement || 'right';
  const platform = useSelector((state: RootState) => state?.common?.platform);
  const doneFirstGrammarCheck = useSelector(
    (state: RootState) => state?.grmr.input.doneFirstGrammarCheck
  );

  const classes = useStyles({ platform });

  const dc = quillDrawer;

  return (
    <Grid
      item
      container
      style={{
        position: 'relative',
        marginRight: 0,
        ...props.controlBarContainer,
      }}
      direction={props.direction || 'column'}
      alignItems="center"
    >
      <Grid
        item
        container
        direction={props.direction || 'column'}
        alignItems="center"
        style={{
          ...props.controlBarGrid,
        }}
      >
        <Grid
          item
          className={`${
            quillDrawer === null || quillDrawer === undefined
              ? null
              : classes.paddingRightDrawerControls
          }`}
        >
          <Tooltip
            arrow
            placement={tooltipPlacement}
            title={APP_SETTINGS.showToolTips ? 'Settings' : ''}
          >
            <IconButton
              onClick={() => toggleDrawer('GC_SETTINGS', GrammarSettingsDrawer)}
              classes={{ root: classes.iconButton }}
              size="large"
            >
              {/* <SettingsIcon /> */}
              <SettingsOutlinedIcon
                style={{
                  color: dc === 'GC_SETTINGS' ? theme.palette.primary.main : '',
                }}
              />
            </IconButton>
          </Tooltip>
        </Grid>

        <Grid
          item
          className={`${
            quillDrawer === null || quillDrawer === undefined
              ? null
              : classes.paddingRightDrawerControls
          }`}
        >
          <Tooltip
            arrow
            placement={tooltipPlacement}
            title={APP_SETTINGS.showToolTips ? 'Give Feedback' : ''}
          >
            <IconButton
              onClick={() => toggleDrawer('FEEDBACK', FeedbackDrawer)}
              classes={{ root: classes.iconButton }}
              size="large"
            >
              <CommentOutlinedIcon
                style={{
                  color: dc === 'FEEDBACK' ? theme.palette.primary.main : '',
                }}
              />
            </IconButton>
          </Tooltip>
        </Grid>

        {doneFirstGrammarCheck && (
          <Grid
            item
            className={`${
              quillDrawer === null || quillDrawer === undefined
                ? null
                : classes.paddingRightDrawerControls
            }`}
          >
            <Tooltip
              arrow
              placement={tooltipPlacement}
              title={APP_SETTINGS.showToolTips ? 'Statistics' : ''}
            >
              <IconButton
                onClick={() => toggleDrawer('GC_STATISTICS', GrammarStatsDrawer)}
                classes={{ root: classes.iconButton }}
              >
                <SvgIcon
                  fill="none"
                  viewBox="0 0 24 24"
                  style={{ color: dc === 'GC_STATISTICS' ? theme.palette.primary.main : '' }}
                >
                  {/* <path {...statsIcon} fill="inherit" /> */}
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z" />
                </SvgIcon>
              </IconButton>
            </Tooltip>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
